"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormEvents = useFormEvents;
exports.withForm = withForm;
exports.useFormikEvents = exports.formActions = void 0;

var _react = _interopRequireWildcard(require("react"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _formik = require("formik");

var _captureException = require("../helpers/captureException");

var _general = require("../helpers/general");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var formActions = {
  ERROR: 'error',
  LOADING: 'loading',
  RESET: 'reset',
  SUCCESS: 'success'
}; // setFieldError is a formik function to set an error message on each input

exports.formActions = formActions;
var initialState = {
  isLoading: false,
  exception: null,
  errorMessage: null,
  inputErrors: null,
  successMessage: null,
  successDescription: null,
  setFieldError: null,
  response: null
};

var formReducer = function formReducer(state, action) {
  switch (action.type) {
    case formActions.RESET:
      return initialState;

    case formActions.LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: true,
        exception: null,
        errorMessage: null,
        inputErrors: null,
        successMessage: null,
        successDescription: null,
        setFieldError: null
      });

    case formActions.ERROR:
      {
        var _action$payload = action.payload,
            exception = _action$payload.exception,
            errorMessage = _action$payload.errorMessage,
            setFieldError = _action$payload.setFieldError;
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          exception: exception,
          errorMessage: errorMessage || (0, _general.getExceptionInfo)(exception).message,
          inputErrors: (0, _general.getExceptionInfo)(exception).errors,
          setFieldError: setFieldError,
          successMessage: null,
          successDescription: null,
          response: null
        });
      }

    case formActions.SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        exception: null,
        errorMessage: null,
        inputErrors: null,
        successMessage: action.payload.successMessage,
        successDescription: action.payload.successDescription,
        setFieldError: null,
        response: action.payload.response
      });

    default:
      return state;
  }
};

function useFormEvents() {
  var defaultState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useReducer = (0, _react.useReducer)(formReducer, _objectSpread(_objectSpread({}, initialState), defaultState)),
      formState = _useReducer[0],
      dispatch = _useReducer[1];

  (0, _react.useEffect)(function () {
    if (formState.inputErrors && formState.setFieldError) {
      (0, _general.applyFormikFieldErrors)(formState.inputErrors, formState.setFieldError);
    }

    if (formState.exception) {
      var _formState$exception, _formState$exception$;

      (0, _captureException.captureException)(formState.exception, {
        extra: _objectSpread({}, formState === null || formState === void 0 ? void 0 : (_formState$exception = formState.exception) === null || _formState$exception === void 0 ? void 0 : (_formState$exception$ = _formState$exception.response) === null || _formState$exception$ === void 0 ? void 0 : _formState$exception$.data)
      });
    }
  }, [formState]);
  return {
    formState: formState,
    dispatch: dispatch
  };
}

var FormContext = /*#__PURE__*/(0, _react.createContext)();

function Form(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(),
      actions = _useState[0],
      setActions = _useState[1];

  return __jsx(FormContext.Provider, {
    value: {
      setActions: setActions
    }
  }, /*#__PURE__*/(0, _react.cloneElement)(children, _objectSpread({}, actions)));
}

function withForm(Component) {
  return function withFormComponent(props) {
    return __jsx(Form, null, __jsx(Component, props));
  };
}

var useFormikEvents = function useFormikEvents() {
  var defaultState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useFormikContext = (0, _formik.useFormikContext)(),
      setFieldError = _useFormikContext.setFieldError,
      formikProps = (0, _objectWithoutProperties2["default"])(_useFormikContext, ["setFieldError"]);

  var _useFormEvents = useFormEvents(defaultState),
      formState = _useFormEvents.formState,
      dispatch = _useFormEvents.dispatch;

  var _useContext = (0, _react.useContext)(FormContext),
      setActions = _useContext.setActions;

  (0, _react.useEffect)(function () {
    var dispatchSubmit = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(asyncFn) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: formActions.LOADING
                });
                _context.prev = 1;
                _context.next = 4;
                return asyncFn();

              case 4:
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](1);
                dispatch({
                  type: formActions.ERROR,
                  payload: {
                    exception: _context.t0,
                    setFieldError: setFieldError
                  }
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 6]]);
      }));

      return function dispatchSubmit(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    var dispatchSuccess = function dispatchSuccess() {
      var successMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      dispatch({
        type: formActions.RESET
      });

      if (successMessage) {
        dispatch({
          type: formActions.SUCCESS,
          payload: {
            successMessage: successMessage
          }
        });
      }
    };

    setActions(function () {
      return {
        dispatchSubmit: dispatchSubmit,
        dispatchSuccess: dispatchSuccess
      };
    });
  }, [dispatch, setActions, setFieldError]);
  return {
    formState: formState,
    dispatch: dispatch,
    formik: _objectSpread({}, formikProps)
  };
};

exports.useFormikEvents = useFormikEvents;